/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TCreateProjectRequest, TCreateProjectModel, IMappers, TCreateProjectResponse } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IProjectCreateResponse } from '../../entities/projects/ProjectCreateResponse';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createCreateProjectModel(parameters: TCreateProjectRequest): TCreateProjectModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'promotions-flow-control',
    pathApi: '/v1/create-project/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface ICreateProjectOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TCreateProjectRequest;
}

export async function fetchCreateProject<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICreateProjectOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCreateProjectResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCreateProjectModel(parameters),
    config,
  )) as FetchResponse<TCreateProjectResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IProjectCreateResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCreateProjectResponse>;
}
